import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';

type GetCustomWorksheetTemplatesOverviewResponse = {
    published: number;
    unpublished: number;
    archived: number;
};

async function getCustomWorksheetTemplatesOverview(): Promise<GetCustomWorksheetTemplatesOverviewResponse | null> {
    const { data } = await api.get(`/templates/custom-worksheets/overview`);
    return data;
}

export function useCustomWorksheetTemplatesOverview(): UseQueryResult<GetCustomWorksheetTemplatesOverviewResponse, AxiosError> {
    return useQuery(['custom-worksheet-templates', 'overview'], getCustomWorksheetTemplatesOverview, { keepPreviousData: true });
}
